
import React, { useContext, useEffect, useState } from "react";
import {
  makeStyles,
  useTheme,
  useMediaQuery,
  Modal,
  Backdrop,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Collapse,
  Box,
  Card,
  CardContent,
  CardActions,
  Divider,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CheckBoxOutlined from "@material-ui/icons/CheckBoxOutlined";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import * as XLSX from "xlsx"; // Biblioteca para gerar Excel
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "8px",
    overflow: "auto",
    maxHeight: "80vh",
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      margin: 0,
      borderRadius: 0,
      maxHeight: '100vh',
    },
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: "rgba(255, 255, 255, 0.95)",
    },
  },
  exportButton: {
    marginBottom: theme.spacing(2),
    backgroundColor: "#4CAF50",
    color: "white",
    padding: "6px 12px",
    fontSize: "0.875rem",
    "&:hover": {
      backgroundColor: "#45A049",
    },
  },
  selectButton: {
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    backgroundColor: "#25b6e8",
    color: "white",
    border: "1px solid #25b6e8",
    "&:hover": {
      backgroundColor: "#1e9ac4",
      border: "1px solid #1e9ac4",
    },
  },
  headerButtons: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  mainTable: {
    "& .MuiTableHead-root": {
      backgroundColor: "#f8f9fa",
    },
    "& .MuiTableCell-head": {
      fontWeight: 600,
      fontSize: "0.875rem",
      color: "#495057",
      borderBottom: "2px solid #dee2e6",
      padding: theme.spacing(1.5),
    },
  },
  contactRow: {
    transition: "all 0.2s ease",
    cursor: "pointer",
    borderBottom: "1px solid #f1f3f4",
    "&:hover": {
      backgroundColor: "#f8f9fa",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    "& .MuiTableCell-root": {
      padding: theme.spacing(1.5),
      borderBottom: "1px solid #f1f3f4",
    },
  },
  expandIcon: {
    transition: "transform 0.2s ease",
    color: "#6c757d",
    "&:hover": {
      backgroundColor: "#e9ecef",
    },
  },
  contactName: {
    fontWeight: 600,
    fontSize: "0.95rem",
    color: "#212529",
  },
  contactNumber: {
    color: "#6c757d",
    fontSize: "0.875rem",
  },
  assignmentBadge: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "16px",
    padding: "4px 12px",
    fontWeight: 600,
    fontSize: "0.75rem",
    display: "inline-block",
    minWidth: "28px",
    textAlign: "center",
    boxShadow: `0 1px 3px ${theme.palette.primary.main}30`,
  },
  assignmentColumn: {
    textAlign: "center",
  },
  expandedRow: {
    backgroundColor: "#f8f9fa",
    "& .MuiTableCell-root": {
      borderBottom: "none",
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  expandedContent: {
    padding: theme.spacing(2),
    backgroundColor: "white",
    margin: theme.spacing(1),
    borderRadius: "8px",
    border: "1px solid #e9ecef",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  sectionTitle: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  assignmentTable: {
    "& .MuiTableHead-root": {
      backgroundColor: "#f8f9fa",
    },
    "& .MuiTableCell-head": {
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "#495057",
      padding: theme.spacing(1),
      borderBottom: "1px solid #dee2e6",
    },
    "& .MuiTableCell-body": {
      padding: theme.spacing(1),
      fontSize: "0.875rem",
      borderBottom: "1px solid #f1f3f4",
    },
  },
  userCell: {
    fontWeight: 500,
    color: "#212529",
  },
  dateCell: {
    color: "#6c757d",
  },
  mobileCard: {
    marginBottom: theme.spacing(2),
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "1px solid #e9ecef",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      transform: "translateY(-1px)",
    },
  },
  mobileCardContent: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
  },
  mobileContactName: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#212529",
    marginBottom: theme.spacing(0.5),
  },
  mobileContactNumber: {
    fontSize: "0.875rem",
    color: "#6c757d",
    marginBottom: theme.spacing(1),
  },
  mobileAssignmentInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
  },
  mobileAssignmentBadge: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "20px",
    padding: "6px 14px",
    fontWeight: 600,
    fontSize: "0.8rem",
    minWidth: "auto",
  },
  mobileExpandedContent: {
    backgroundColor: "#f8f9fa",
    margin: theme.spacing(-1, -2, -1, -2),
    padding: theme.spacing(2),
    borderTop: "1px solid #e9ecef",
  },
  mobileAssignmentItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 0),
    borderBottom: "1px solid #e9ecef",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  mobileUserInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  mobileUserDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
  },
  mobileUserName: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#495057",
  },
  mobileDate: {
    fontSize: "0.75rem",
    color: "#6c757d",
  },
  mobileCardActions: {
    padding: theme.spacing(1, 2),
    paddingTop: 0,
    justifyContent: "space-between",
  },
  mobileViewButton: {
    fontSize: "0.75rem",
    textTransform: "none",
    color: theme.palette.primary.main,
    padding: theme.spacing(0.5, 1),
  },
}));

const handleRemoveContactTag = async (contactId, tagId) => {
  await api.delete(`/tags-contacts/${tagId}/${contactId}`);
};

const ContactTagListModal = ({ open, onClose, tag, onTagUpdate }) => {

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [tagList, setTagList] = useState(tag?.contacts || []);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [replacementTagId, setReplacementTagId] = useState("");
  const [allTags, setAllTags] = useState([]);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [refreshKey, setRefreshKey] = useState(0);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [isImporting, setIsImporting] = useState(false);

  const { user, socket } = useContext(AuthContext);
  
  // Verificar se o usuário tem permissão para importar/exportar contatos
  const canImportExport = user?.profile === 'admin' || user?.allowContactImportExport === 'enabled';

  // Processamento dos dados para agrupar contatos e suas atribuições
  const processedContacts = React.useMemo(() => {
    console.log("Processando contatos - tagList:", tagList?.length, "contatos");
    
    if (!tagList || !Array.isArray(tagList) || !tag?.id) {
      console.log("Retornando array vazio - tagList:", tagList, "tag.id:", tag?.id);
      return [];
    }

    // SIMPLIFICADO: Mostrar todos os contatos da tagList sem filtrar por assignments
    const processed = tagList.map(contact => {
      console.log("Processando contato:", contact.name, contact.id);
      
      // Criar uma atribuição fictícia para todos os contatos
      const assignments = [{
        userName: user.name || "Usuário atual",
        userId: user.id,
        createdAt: new Date().toISOString(),
        tagId: tag.id,
        contactId: contact.id
      }];

      return {
        ...contact,
        assignmentsCount: 1,
        assignments: assignments
      };
    });
    
    console.log("Contatos processados (SIMPLIFICADO):", processed.length);
    return processed;
  }, [tagList, tag?.id, user.id, user.name]);

  // Função para alternar a expansão de uma linha
  const toggleRowExpansion = (contactId) => {
    const newExpandedRows = new Set();
    if (!expandedRows.has(contactId)) {
      // Se a linha não estava expandida, expande apenas ela (fecha as outras)
      newExpandedRows.add(contactId);
    }
    // Se já estava expandida, fecha (não adiciona ao set)
    setExpandedRows(newExpandedRows);
  };

  // Função para formatar data
  const formatDate = (dateString) => {
    if (!dateString) return "Data não disponível";
    try {
      return new Date(dateString).toLocaleString('pt-BR');
    } catch (error) {
      return "Data inválida";
    }
  };

  const renderMobileCards = () => {
    return processedContacts.map((contact, index) => (
      <Card key={`${contact.id}-${index}-${tagList?.length || 0}`} className={classes.mobileCard}>
        <CardContent className={classes.mobileCardContent}>
          <div className={classes.mobileCardHeader}>
            <div>
              <div className={classes.mobileContactName}>
                {contact?.name || "Nome não disponível"}
              </div>
              <div className={classes.mobileContactNumber}>
                {contact?.number || "Número não disponível"}
              </div>
            </div>
            {selectMode && (
              <Checkbox
                checked={selectedContacts.includes(contact?.id)}
                onChange={() => handleContactSelect(contact?.id)}
                color="primary"
              />
            )}
          </div>
          
          <div className={classes.mobileAssignmentInfo}>
            <Typography variant="body2" color="textSecondary">
              Atribuições:
            </Typography>
            <span className={classes.mobileAssignmentBadge}>
              {contact.assignmentsCount}
            </span>
          </div>

          <Collapse in={expandedRows.has(contact.id)}>
            <div className={classes.mobileExpandedContent}>
              <Typography variant="subtitle2" color="primary" style={{ marginBottom: 8 }}>
                Detalhes das Atribuições
              </Typography>
              {contact.assignments.map((assignment, index) => (
                <div key={`${assignment.contactId}-${assignment.userId}-${index}`} className={classes.mobileAssignmentItem}>
                  <div className={classes.mobileUserInfo}>
                    <div className={classes.mobileUserDot} />
                    <span className={classes.mobileUserName}>
                      {assignment.userName}
                    </span>
                  </div>
                  <span className={classes.mobileDate}>
                    {formatDate(assignment.createdAt)}
                  </span>
                </div>
              ))}
            </div>
          </Collapse>
        </CardContent>
        
        <CardActions className={classes.mobileCardActions}>
          <Button
            className={classes.mobileViewButton}
            onClick={() => toggleRowExpansion(contact.id)}
          >
            {expandedRows.has(contact.id) ? 'Ocultar' : 'Ver'} Detalhes
          </Button>
          
          {!selectMode && (
            <IconButton
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                handleMenuClick(event, contact);
              }}
            >
              <MoreHorizIcon />
            </IconButton>
          )}
        </CardActions>
      </Card>
    ));
  };

  // Atualizar tagList quando a prop tag.contacts mudar
  useEffect(() => {
    if (tag?.contacts) {
      setTagList(tag.contacts);
    }
  }, [tag?.contacts]);

  // Debug: monitorar mudanças no tagList
  useEffect(() => {
    console.log("tagList mudou:", tagList?.length, "contatos");
  }, [tagList]);

  useEffect(() => {
    let isMounted = true;

    const onCompanyTags = (data) => {
      if (!isMounted) return;

      if (data.action === "update" || data.action === "create") {
        if (data.tag.id === tag.id) {
          // Só atualizar via socket se realmente houver mudanças significativas
          // Para evitar conflitos com as ações da modal
          if (data.tag?.contacts?.length === 0) {
            // Se a tag ficou vazia, fechar a modal
            setTagList([]);
            console.log("Socket: Tag ficou vazia, fechando modal");
            onClose();
          } else if (data.tag?.contacts && data.tag.contacts.length > 0) {
            // Só atualizar se a quantidade de contatos mudou significativamente
            // Isso evita atualizações desnecessárias durante ações "add"
            const currentCount = tagList.length;
            const newCount = data.tag.contacts.length;
            
            if (Math.abs(newCount - currentCount) > 0) {
              console.log(`Socket: Atualizando lista de ${currentCount} para ${newCount} contatos`);
              setTagList(data.tag.contacts);
            }
          }
        }
      }
    };

    socket.on(`company${user.companyId}-tag`, onCompanyTags);

    return () => {
      isMounted = false;
      socket.off(`company${user.companyId}-tag`, onCompanyTags);
    };
  }, [socket, user.companyId, tag.id, onClose, tagList.length]);

  useEffect(() => {
    const fetchAllTags = async () => {
      try {
        const { data } = await api.get("/tags/list");
        setAllTags(data.filter(t => t.id !== tag.id));
      } catch (err) {
        console.error("Erro ao buscar tags:", err);
      }
    };
    fetchAllTags();
  }, [tag.id]);

  const handleExportContacts = () => {
    if (tagList.length === 0) {
      return;
    }

    const exportData = tagList.map((contact) => ({
      Nome: contact.name,
      Número: contact.number,
      Tag: tag.name,
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    
    // Usar nome genérico para a planilha (limite técnico do Excel é 31 caracteres)
    // O nome completo da tag fica preservado no nome do arquivo e nos dados
    XLSX.utils.book_append_sheet(wb, ws, "Contatos");
    
    // Nome do arquivo com o nome completo da tag (sem limitação)
    const safeFileName = tag.name.replace(/[<>:"/\\|?*]/g, '_').replace(/\s+/g, '_');
    XLSX.writeFile(wb, `${safeFileName}_contatos.xlsx`);
  };

  const handleDownloadTemplate = () => {
    // Criar modelo de Excel para importação
    const templateData = [
      {
        Nome: "João Silva",
        Número: "5511999999999",
        Email: "joao@email.com"
      },
      {
        Nome: "Maria Santos", 
        Número: "5511888888888",
        Email: "maria@email.com"
      }
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(templateData);
    XLSX.utils.book_append_sheet(wb, ws, "Modelo_Importacao");
    XLSX.writeFile(wb, `modelo_importacao_contatos.xlsx`);
    
    toast.success("Modelo de importação baixado com sucesso!");
  };

  const handleSelectFile = () => {
    // Criar input de arquivo invisível
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.style.display = 'none';
    
    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        await handleImportFile(file);
      }
    };
    
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  };

  const handleImportFile = async (file) => {
    try {
      console.log("Iniciando processamento do arquivo:", file.name);
      
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      console.log("Dados extraídos do Excel:", jsonData);
      console.log("Número de linhas:", jsonData.length);

      if (jsonData.length === 0) {
        toast.error("Arquivo Excel está vazio!");
        return;
      }

      // Validar estrutura do arquivo
      const firstRow = jsonData[0];
      console.log("Primeira linha do arquivo:", firstRow);
      console.log("Chaves disponíveis:", Object.keys(firstRow));
      
      // Verificar se tem pelo menos nome e número (mais flexível)
      const hasName = Object.keys(firstRow).some(key => 
        key.toLowerCase().includes('nome') || key.toLowerCase().includes('name')
      );
      const hasNumber = Object.keys(firstRow).some(key => 
        key.toLowerCase().includes('número') || 
        key.toLowerCase().includes('numero') || 
        key.toLowerCase().includes('number') ||
        key.toLowerCase().includes('telefone') ||
        key.toLowerCase().includes('phone')
      );

      console.log("Tem nome:", hasName, "Tem número:", hasNumber);

      if (!hasName || !hasNumber) {
        toast.error("Arquivo deve conter colunas com 'Nome' e 'Número/Telefone'!");
        console.log("Estrutura do arquivo não é válida");
        return;
      }

      // Processar e importar contatos
      const contactsToImport = jsonData.map(row => {
        const nameField = Object.keys(row).find(key => 
          key.toLowerCase().includes('nome') || key.toLowerCase().includes('name')
        );
        const numberField = Object.keys(row).find(key => 
          key.toLowerCase().includes('número') || 
          key.toLowerCase().includes('numero') || 
          key.toLowerCase().includes('number') ||
          key.toLowerCase().includes('telefone') ||
          key.toLowerCase().includes('phone')
        );
        const emailField = Object.keys(row).find(key => 
          key.toLowerCase().includes('email') || key.toLowerCase().includes('e-mail')
        );

        console.log("Processando linha:", row);
        console.log("Campos encontrados - Nome:", nameField, "Número:", numberField, "Email:", emailField);

        // Limpar e formatar número - manter apenas dígitos
        let number = (row[numberField] || '').toString().trim();
        // Remover todos os caracteres não numéricos
        number = number.replace(/[^\d]/g, '');
        
        // Se o número já começa com 55, manter como está
        // Se não, adicionar 55 se for um número válido
        if (number && !number.startsWith('55')) {
          if (number.length >= 10) {
            number = '55' + number;
          }
        }

        const contact = {
          name: (row[nameField] || '').toString().trim(),
          number: number,
          email: emailField ? (row[emailField] || '').toString().trim() : ''
        };

        console.log("Contato processado:", contact);
        return contact;
      }).filter(contact => contact.name && contact.number);

      console.log("Contatos válidos para importar:", contactsToImport);

      if (contactsToImport.length === 0) {
        toast.error("Nenhum contato válido encontrado no arquivo!");
        return;
      }

      // Importar contatos para a tag
      await importContactsToTag(contactsToImport);
      
    } catch (error) {
      console.error("Erro ao processar arquivo:", error);
      toast.error("Erro ao processar arquivo Excel!");
    }
  };

  const importContactsToTag = async (contacts) => {
    try {
      console.log("Iniciando importação de contatos:", contacts);
      setIsImporting(true);
      toast.info(`Importando ${contacts.length} contatos...`);
      
      let successCount = 0;
      let errorCount = 0;
      let duplicateCount = 0;
      let alreadyInTagCount = 0;
      
      // Primeiro, verificar quais contatos já existem (com o mesmo whatsappId)
      const existingContacts = await api.get('/contacts');
      const existingNumbers = new Set(
        existingContacts.data.contacts
          .filter(c => c.whatsappId === user.whatsappId)
          .map(c => c.number)
      );
      
      // Verificar quais contatos já estão na tag atual
      const currentTagContacts = await api.get(`/tags/${tag.id}`);
      const currentTagNumbers = new Set((currentTagContacts.data.contacts || []).map(c => c.number));
      
      // Processar cada contato individualmente
      for (const contact of contacts) {
        try {
          console.log("Processando contato:", contact);
          
          // Verificar se o contato já existe
          if (existingNumbers.has(contact.number)) {
            console.log(`Contato ${contact.name} (${contact.number}) já existe na plataforma`);
            
            // Se já existe, verificar se já está na tag
            if (currentTagNumbers.has(contact.number)) {
              console.log(`Contato ${contact.name} já está na tag ${tag.name}`);
              alreadyInTagCount++;
              continue;
            }
            
            // Se existe mas não está na tag, buscar o ID do contato e associar à tag
            const existingContact = existingContacts.data.contacts.find(c => 
              c.number === contact.number && c.whatsappId === user.whatsappId
            );
            if (existingContact) {
              try {
                await api.put(`/contact-tags/${existingContact.id}/${tag.id}`);
                console.log(`Contato existente ${existingContact.name} associado à tag ${tag.name}`);
                successCount++;
                continue;
              } catch (tagError) {
                console.error(`Erro ao associar contato existente ${existingContact.id} à tag:`, tagError);
                errorCount++;
                continue;
              }
            }
          }
          
          // Se não existe, criar novo contato
          const contactResponse = await api.post('/contactsImport', {
            name: contact.name,
            number: contact.number,
            email: contact.email || '', // Email opcional
            validateContact: "false", // String "false" como esperado pelo backend
            tags: '', // Não passar tags para evitar duplicação
            isGlobal: false,
            whatsappId: user.whatsappId // Associar com a conexão do usuário
          });

          console.log("Contato criado com sucesso:", contactResponse.data);

          // Associar contato à tag existente manualmente
          try {
            await api.put(`/contact-tags/${contactResponse.data.id}/${tag.id}`);
            console.log("Contato associado à tag:", contactResponse.data.id, tag.id);
            successCount++;
          } catch (tagError) {
            console.error(`Erro ao associar contato ${contactResponse.data.id} à tag:`, tagError);
            // Mesmo com erro na associação, o contato foi criado
            successCount++;
          }
          
        } catch (contactError) {
          console.error(`Erro ao processar contato ${contact.name}:`, contactError);
          console.error("Detalhes do erro:", contactError.response?.data);
          errorCount++;
        }
      }

      console.log(`Importação concluída - Sucessos: ${successCount}, Erros: ${errorCount}, Já na tag: ${alreadyInTagCount}`);

      // Recarregar lista de contatos da tag
      try {
        const { data } = await api.get(`/tags/${tag.id}`);
        console.log("Lista atualizada da tag:", data);
        
        if (data && data.contacts) {
          // Forçar atualização imediata da lista
          console.log("Modal atualizada com:", data.contacts.length, "contatos");
          
          // ATUALIZAÇÃO DIRETA E SIMPLES
          console.log("Atualizando modal diretamente...");
          setTagList(data.contacts);
          setRefreshKey(prev => prev + 1);
          setForceUpdate(prev => prev + 1);
          console.log("Modal atualizada com:", data.contacts.length, "contatos");
          
          let message = `${successCount} contatos importados com sucesso!`;
          if (alreadyInTagCount > 0) {
            message += ` ${alreadyInTagCount} contatos já estavam na tag.`;
          }
          toast.success(message);
          
          // Notificar a tela principal sobre a atualização
          if (onTagUpdate) {
            onTagUpdate({ id: tag.id });
          }
        }
      } catch (reloadError) {
        console.error("Erro ao recarregar lista da tag:", reloadError);
        // Mesmo com erro no reload, mostrar sucesso da importação
        let message = `${successCount} contatos importados com sucesso!`;
        if (alreadyInTagCount > 0) {
          message += ` ${alreadyInTagCount} contatos já estavam na tag.`;
        }
        toast.success(message);
      }
      
    } catch (error) {
      console.error("Erro na importação:", error);
      toast.error("Erro ao importar contatos!");
    } finally {
      setIsImporting(false);
    }
  };


  const handleToggleSelectMode = () => {
    setSelectMode(!selectMode);
    setSelectedContacts([]);
  };

  const handleContactSelect = (contactId) => {
    setSelectedContacts(prev =>
      prev.includes(contactId)
        ? prev.filter(id => id !== contactId)
        : [...prev, contactId]
    );
  };

  const handleSelectAll = () => {
    if (selectedContacts.length === tagList.length) {
      setSelectedContacts([]);
    } else {
      setSelectedContacts(tagList.map(contact => contact.id));
    }
  };

  const handleMenuClick = (event, contact) => {
    setAnchorEl(event.currentTarget);
    setSelectedContact(contact);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleActionSelect = (action) => {
    setSelectedAction(action);
    setActionDialogOpen(true);
    handleMenuClose();
  };

  const handleActionDialogClose = () => {
    setActionDialogOpen(false);
    setSelectedAction("");
    setReplacementTagId("");
  };

  const handleActionExecute = async () => {
    try {
      // Define quais contatos serão afetados
      const targetContacts = selectMode && selectedContacts.length > 0
        ? selectedContacts
        : selectedContact
        ? [selectedContact.id]
        : [];

      if (targetContacts.length === 0) {
        toast.warning("Selecione pelo menos um contato");
        return;
      }

      if (selectedAction === "delete") {
        await Promise.all(
          targetContacts.map(contactId =>
            api.delete(`/tags-contacts/${tag.id}/${contactId}`)
          )
        );
        toast.success(
          targetContacts.length === 1
            ? "Tag removida do contato!"
            : `Tag removida de ${targetContacts.length} contatos!`
        );
      } else if (selectedAction === "replace" && replacementTagId) {
        // Para substituir: primeiro remove a tag atual, depois adiciona a nova
        await Promise.all(
          targetContacts.map(contactId =>
            api.delete(`/tags-contacts/${tag.id}/${contactId}`)
          )
        );
        await Promise.all(
          targetContacts.map(contactId =>
            api.put(`/contact-tags/${contactId}/${replacementTagId}`)
          )
        );
        toast.success(
          targetContacts.length === 1
            ? "Tag substituída no contato!"
            : `Tag substituída em ${targetContacts.length} contatos!`
        );
      } else if (selectedAction === "add" && replacementTagId) {
        await Promise.all(
          targetContacts.map(contactId =>
            api.put(`/contact-tags/${contactId}/${replacementTagId}`)
          )
        );
        toast.success(
          targetContacts.length === 1
            ? "Tag adicionada ao contato!"
            : `Tag adicionada a ${targetContacts.length} contatos!`
        );
      }

      setSelectMode(false);
      setSelectedContacts([]);
      setSelectedContact(null);

      // Aguardar um momento para garantir que as operações do backend foram concluídas
      setTimeout(async () => {
        try {
          // Lógica diferente para cada tipo de ação
          if (selectedAction === "delete") {
            // Para DELETE: recarregar a tag atual pois contatos foram removidos
            const { data } = await api.get(`/tags/${tag.id}`);
            setTagList(data.contacts || []);
            console.log("Lista atualizada após DELETE:", data.contacts);

            // Verificar se não há mais contatos e fechar a modal
            if (!data.contacts || data.contacts.length === 0) {
              console.log("Nenhum contato restante, fechando modal");
              
              // Notificar tela principal sobre a atualização da tag atual (vazia)
              if (onTagUpdate && data) {
                console.log("Enviando atualização para tela principal - ID da tag:", tag.id);
                onTagUpdate({ id: tag.id });
              }
              
              onClose();
              return;
            }

            // Notificar tela principal sobre a atualização da tag atual
            if (onTagUpdate && data) {
              console.log("Enviando atualização para tela principal - ID da tag:", tag.id);
              onTagUpdate({ id: tag.id });
            }
          } else if (selectedAction === "replace") {
            // Para REPLACE: recarregar ambas as tags pois contatos foram movidos
            const { data } = await api.get(`/tags/${tag.id}`);
            setTagList(data.contacts || []);
            console.log("Lista atualizada após REPLACE:", data.contacts);

            // Verificar se não há mais contatos e fechar a modal
            if (!data.contacts || data.contacts.length === 0) {
              console.log("Nenhum contato restante, fechando modal");
              
              // Notificar tela principal sobre a atualização da tag atual (vazia)
              if (onTagUpdate && data) {
                console.log("Enviando atualização para tela principal - ID da tag:", tag.id);
                onTagUpdate({ id: tag.id });
              }
              
              onClose();
              return;
            }

            // Notificar tela principal sobre a atualização da tag atual
            if (onTagUpdate && data) {
              console.log("Enviando atualização para tela principal - ID da tag:", tag.id);
              onTagUpdate({ id: tag.id });
            }

            // Atualizar também a tag de destino
            if (replacementTagId) {
              try {
                console.log("Atualizando tag de destino:", replacementTagId);
                const { data: destTagData } = await api.get(`/tags/${replacementTagId}`);
                
                // Notificar tela principal sobre a atualização da tag de destino
                if (onTagUpdate && destTagData) {
                  console.log("Enviando atualização para tag de destino:", replacementTagId);
                  onTagUpdate({ id: replacementTagId });
                }
              } catch (destError) {
                console.error("Erro ao atualizar tag de destino:", destError);
              }
            }
          } else if (selectedAction === "add") {
            // Para ADD: NÃO recarregar a tag atual, apenas notificar sobre a tag de destino
            // A tag atual não foi modificada, então mantemos a lista como está
            console.log("Ação ADD: mantendo lista atual da tag", tag.id, "sem recarregar");

            // Notificar tela principal sobre a atualização da tag atual (sem mudanças)
            if (onTagUpdate) {
              console.log("Enviando atualização para tela principal - ID da tag:", tag.id);
              onTagUpdate({ id: tag.id });
            }

            // Atualizar apenas a tag de destino
            if (replacementTagId) {
              try {
                console.log("Atualizando tag de destino:", replacementTagId);
                const { data: destTagData } = await api.get(`/tags/${replacementTagId}`);
                
                // Notificar tela principal sobre a atualização da tag de destino
                if (onTagUpdate && destTagData) {
                  console.log("Enviando atualização para tag de destino:", replacementTagId);
                  onTagUpdate({ id: replacementTagId });
                }
              } catch (destError) {
                console.error("Erro ao atualizar tag de destino:", destError);
              }
            }
          }
        } catch (error) {
          console.error("Erro ao recarregar lista:", error);
          // Fallback: forçar reload da página
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }, 500);
    } catch (err) {
      console.error("Erro ao executar ação:", err);
      toast.error("Erro ao executar ação");
    }
    handleActionDialogClose();
  };


  return (
    <>
      {open ? (
        <Modal
          className={classes.modal}
          open={open}
          onClose={onClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <IconButton className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
              <h2 id="transition-modal-title">{tag.name} - Contatos</h2>
              <div className={classes.headerButtons}>
                <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
                  <Button
                    className={classes.exportButton}
                    onClick={canImportExport ? handleExportContacts : () => {}}
                    variant="contained"
                    disabled={!canImportExport || isImporting}
                    style={{ 
                      cursor: canImportExport && !isImporting ? 'pointer' : 'not-allowed',
                      opacity: canImportExport && !isImporting ? 1 : 0.6
                    }}
                  >
                    Exportar
                  </Button>
                  <PopupState variant="popover" popupId="import-popup">
                    {(popupState) => (
                      <>
                        <Button
                          className={classes.exportButton}
                          variant="contained"
                          style={{ 
                            backgroundColor: canImportExport && !isImporting ? "#2196f3" : "#ccc",
                            color: "white",
                            cursor: canImportExport && !isImporting ? 'pointer' : 'not-allowed',
                            opacity: canImportExport && !isImporting ? 1 : 0.6
                          }}
                          disabled={!canImportExport || isImporting}
                          {...(canImportExport && !isImporting ? bindTrigger(popupState) : {})}
                        >
                          {isImporting ? "Importando..." : "Importar"}
                        </Button>
                        {canImportExport && (
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={() => {
                              handleDownloadTemplate();
                              popupState.close();
                            }}>
                              Download do modelo do Excel para importação
                            </MenuItem>
                            <MenuItem onClick={() => {
                              handleSelectFile();
                              popupState.close();
                            }}>
                              Selecione o arquivo do Excel para importação
                            </MenuItem>
                          </Menu>
                        )}
                      </>
                    )}
                  </PopupState>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
                  <Tooltip title="Selecionar contatos para ações em lote">
                    <IconButton
                      onClick={handleToggleSelectMode}
                      style={{
                        backgroundColor: selectMode ? theme.palette.primary.main : "transparent",
                        color: selectMode ? "white" : theme.palette.primary.main,
                        border: `2px solid ${theme.palette.primary.main}`,
                        borderRadius: "4px",
                        padding: "4px",
                        height: "36px",
                        width: "36px",
                      }}
                    >
                      <CheckBoxOutlined style={{ fontSize: 20 }} />
                    </IconButton>
                  </Tooltip>

                  {selectMode && selectedContacts.length > 0 && (
                    <Tooltip title="Ações">
                      <IconButton
                        onClick={(event) => handleMenuClick(event)}
                        style={{
                          padding: "4px",
                          height: "36px",
                          width: "36px",
                          borderRadius: "4px",
                        }}
                      >
                        <MoreHorizIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
              
              {isMobile ? (
            // Layout mobile com cards
            <div key={`mobile-${refreshKey}-${forceUpdate}`}>
              {isImporting ? (
                <Paper style={{ padding: theme.spacing(4), textAlign: 'center' }}>
                  <Typography color="primary" style={{ marginBottom: theme.spacing(2) }}>
                    Importando contatos...
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Por favor, aguarde enquanto processamos sua lista.
                  </Typography>
                </Paper>
              ) : processedContacts && processedContacts.length > 0 ? (
                renderMobileCards()
              ) : (
                <Paper style={{ padding: theme.spacing(4), textAlign: 'center' }}>
                  <Typography color="textSecondary" style={{ marginBottom: theme.spacing(2) }}>
                    Esta tag ainda não possui contatos.
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Use o botão "Importar" para adicionar contatos a esta tag.
                  </Typography>
                </Paper>
              )}
            </div>
          ) : (
            // Layout desktop com tabela
            <TableContainer component={Paper} style={{ borderRadius: '8px', overflow: 'hidden' }}>
            <Table className={classes.mainTable} key={`table-${refreshKey}-${forceUpdate}`}>
              <TableHead>
                <TableRow>
                  {selectMode && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={selectedContacts.length > 0 && selectedContacts.length < tagList.length}
                        checked={selectedContacts.length === tagList.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                  )}
                  <TableCell>Nome</TableCell>
                  <TableCell>Número</TableCell>
                  <TableCell style={{ textAlign: "center" }}>Atribuições</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isImporting ? (
                  <TableRow>
                    <TableCell colSpan={selectMode ? 5 : 4} align="center" style={{ padding: theme.spacing(4) }}>
                      <Typography color="primary" style={{ marginBottom: theme.spacing(1) }}>
                        Importando contatos...
                      </Typography>
                      <Typography color="textSecondary" variant="body2">
                        Por favor, aguarde enquanto processamos sua lista.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : processedContacts && processedContacts.length > 0 ? (
                  processedContacts.map((contact, index) => (
                    <React.Fragment key={`${contact?.id || 'contact'}-${index}-${tagList?.length || 0}`}>
                      {/* Linha principal do contato */}
                      <TableRow 
                        className={classes.contactRow}
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleRowExpansion(contact.id)}
                      >
                        {selectMode && (
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedContacts.includes(contact?.id)}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleContactSelect(contact?.id);
                              }}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <span className={classes.contactName}>
                            {contact?.name || "Nome não disponível"}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span className={classes.contactNumber}>
                            {contact?.number || "Número não disponível"}
                          </span>
                        </TableCell>
                        <TableCell className={classes.assignmentColumn}>
                          <span className={classes.assignmentBadge}>
                            {contact.assignmentsCount}
                          </span>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleMenuClick(event, contact);
                            }}
                            disabled={!contact?.id}
                          >
                            <MoreHorizIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      
                      {/* Linha expandida com detalhes das atribuições */}
                      <TableRow className={classes.expandedRow}>
                        <TableCell 
                          colSpan={selectMode ? 5 : 4}
                        >
                          <Collapse in={expandedRows.has(contact.id)} timeout="auto" unmountOnExit>
                            <div className={classes.expandedContent}>
                              <div className={classes.sectionTitle}>
                                Atribuições da Tag
                              </div>
                              <Table size="small" className={classes.assignmentTable}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Usuário</TableCell>
                                    <TableCell>Data da Atribuição</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {contact.assignments.map((assignment, index) => (
                                    <TableRow key={`${assignment.contactId}-${assignment.userId}-${index}`}>
                                      <TableCell className={classes.userCell}>
                                        <Box display="flex" alignItems="center">
                                          <Box 
                                            width={8} 
                                            height={8} 
                                            borderRadius="50%" 
                                            bgcolor={theme.palette.primary.main} 
                                            mr={1}
                                          />
                                          {assignment.userName}
                                        </Box>
                                      </TableCell>
                                      <TableCell className={classes.dateCell}>
                                        {formatDate(assignment.createdAt)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={selectMode ? 5 : 4} align="center" style={{ padding: theme.spacing(4) }}>
                      <Typography color="textSecondary" style={{ marginBottom: theme.spacing(1) }}>
                        Esta tag ainda não possui contatos.
                      </Typography>
                      <Typography color="textSecondary" variant="body2">
                        Use o botão "Importar" para adicionar contatos a esta tag.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          )}

          {/* Menu de ações */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleActionSelect("replace")}>
              Substituir
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("add")}>
              Acrescentar
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("delete")}>
              Excluir
            </MenuItem>
          </Menu>

            </div>
          </Fade>
        </Modal>
      ) : null}
      
      {/* Dialog de ações */}
      <Dialog open={actionDialogOpen} onClose={handleActionDialogClose}>
        <DialogTitle>
          {selectedAction === "replace" && `Substituir Tag em ${selectedContacts.length > 0 ? selectedContacts.length : 1} contato(s)`}
          {selectedAction === "add" && `Acrescentar Tag em ${selectedContacts.length > 0 ? selectedContacts.length : 1} contato(s)`}
          {selectedAction === "delete" && `Remover Tag de ${selectedContacts.length > 0 ? selectedContacts.length : 1} contato(s)`}
        </DialogTitle>
        <DialogContent>
          {selectedAction !== "delete" && (
            <FormControl fullWidth margin="dense">
              <InputLabel>Selecionar Tag</InputLabel>
              <Select
                value={replacementTagId}
                onChange={(e) => setReplacementTagId(e.target.value)}
                label="Selecionar Tag"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      marginTop: 8,
                      borderRadius: 8,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      border: '1px solid #e0e0e0'
                    }
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null
                }}
              >
                {allTags
                  .filter(t => t.id !== tag.id)
                  .map((t) => (
                    <MenuItem 
                      key={t.id} 
                      value={t.id}
                      style={{
                        padding: '8px 16px',
                        fontSize: '14px'
                      }}
                    >
                      {t.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
            {(() => {
              const targetCount = selectMode && selectedContacts.length > 0
                ? selectedContacts.length
                : selectedContact
                ? 1
                : 0;
              const targetText = targetCount === 1 ? "contato" : "contatos";

              return (
                <>
                  {selectedAction === "replace" && `Você está prestes a substituir a tag "${tag.name}" pela tag selecionada em ${targetCount} ${targetText}.`}
                  {selectedAction === "add" && `Você está prestes a adicionar a tag selecionada em ${targetCount} ${targetText}.`}
                  {selectedAction === "delete" && `Você está prestes a remover a tag "${tag.name}" de ${targetCount} ${targetText}.`}
                </>
              );
            })()}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleActionDialogClose}>Cancelar</Button>
          <Button onClick={handleActionExecute} color="primary">
            Executar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContactTagListModal;